<glxy-page *ngIf="actionList$ | async as actionList">
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ actionList?.name }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'LISTS.ACCOUNT_LIST.TITLE' | translate"
        [previousPageUrl]="'/action-lists/manage/'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-actions>
      <mat-menu #actions="matMenu">
        <ng-container *ngIf="actionList.accounts > 0">
          <ng-container *ngFor="let item of availableActions$ | async">
            <button
              mat-menu-item
              (click)="
                showActionOrCTA(
                  item.dialog,
                  item.data,
                  actionList,
                  item.featureId,
                  item.locked,
                  item.useBulkActionsMicroservice
                )
              "
            >
              <span class="menu-item">
                {{ item.name }}
                <mat-icon *ngIf="item.locked">lock</mat-icon>
              </span>
            </button>
          </ng-container>
        </ng-container>
        <button mat-menu-item (click)="showDeleteDialog(actionList)">Delete List</button>
      </mat-menu>
      <button mat-raised-button color="primary" [routerLink]="'/bulk-import/'">Import List</button>
      &nbsp;
      <button mat-raised-button color="primary" [disabled]="actionsDisabled$ | async" [matMenuTriggerFor]="actions">
        Actions
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper [maxWidth]="1160">
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      [(selectedIndex)]="selectedTabIndex"
      (selectedTabChange)="handleTabChange()"
    >
      <mat-tab label="Accounts">
        <ng-template matTabContent>
          <div class="tab-content">
            <app-action-list-accounts [actionListId]="actionListId"></app-action-list-accounts>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="History">
        <ng-template matTabContent>
          <div class="tab-content">
            <app-action-list-history
              [actionListId]="actionListId"
              [actionListName]="actionList?.name"
            ></app-action-list-history>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </glxy-page-wrapper>
</glxy-page>
